import { render } from "./ListeSuivClient.vue?vue&type=template&id=1b8cfa20&ts=true"
import script from "./ListeSuivClient.vue?vue&type=script&lang=ts"
export * from "./ListeSuivClient.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__